import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";
import { IconButton, Stack } from "@mui/material";
import { Check, Close, Preview } from "@mui/icons-material";
import dummyImage from "assets/images/userDummy.png";

export default function promotionalTableData({ peopleList, onReject, onApprove, onView }) {
  const formatDate = (dateString) => {
    const date = new Date(dateString).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
    return date;
  };
  const User = ({ image, name }) => {
    const imageSource = image ? image : dummyImage;
    return (
      <MDBox display="flex" alignItems="center" lineHeight={1}>
        <MDAvatar src={imageSource} alt={name} size="sm" />
        <MDBox ml={2} lineHeight={1}>
          <MDTypography display="block" variant="button" fontWeight="medium">
            {name}
          </MDTypography>
        </MDBox>
      </MDBox>
    );
  };

  return {
    columns: [
      { Header: "Preview", accessor: "preview", align: "left" },
      { Header: "Index", accessor: "index", align: "center" },
      { Header: "Uploaded By", accessor: "uploaded", width: "20%", align: "left" },
      { Header: "Continents", accessor: "continents", align: "left" },
      { Header: "Uploaded At", accessor: "uploadedAt", align: "center" },
      { Header: "Status", accessor: "status", align: "center" },
      { Header: "Actions", accessor: "actions", align: "center" },
    ],

    rows: peopleList.map((person) => ({
      continents: (
        <MDTypography component="span" variant="caption" color="text" fontWeight="medium">
          {person?.promotionContinents.map((item) => item?.name).join(", ")}
        </MDTypography>
      ),
      preview: (
        <MDAvatar
          src={person?.thumbnailPath}
          variant="square"
          sx={{
            objectFit: "contain",
            width: 60,
            height: 60,
            borderRadius: 2,
          }}
        />
      ),
      index: (
        <MDTypography component="span" variant="caption" color="text" fontWeight="medium">
          {person?.activity?.name}
        </MDTypography>
      ),
      uploaded: <User image={person?.user?.profileImage} name={person?.user?.name} />,
      status: (
        <MDBox ml={-1}>
          <MDBadge
            badgeContent={
              person?.isApproved === null
                ? "Pending"
                : person?.isApproved === true
                ? "Approved"
                : "Rejected"
            }
            color={
              person?.isApproved === null
                ? "warning"
                : person?.isApproved === true
                ? "success"
                : "error"
            }
            variant="gradient"
            size="sm"
          />
        </MDBox>
      ),
      uploadedAt: (
        <MDTypography component="span" variant="caption" color="text" fontWeight="medium">
          {formatDate(person?.createdAt)}
        </MDTypography>
      ),
      actions: (
        <Stack direction="row" spacing={1} justifyContent="flex-end">
          <IconButton title="Preview" onClick={() => onView(person?.fileUrl)}>
            <Preview />
          </IconButton>
          {person?.isApproved === null && (
            <>
              <IconButton color="success" title="Approve" onClick={() => onApprove(person?.id)}>
                <Check />
              </IconButton>
              <IconButton color="error" title="Reject" onClick={() => onReject(person?.id)}>
                <Close />
              </IconButton>
            </>
          )}
        </Stack>
      ),
    })),
  };
}
